import React,{Component} from 'react';
import {createMarkup} from './Factory';
import {UISref} from 'ui-router-react'; 

class SidebarKalender extends Component {
	constructor(props) {
		super(props);
		this.state = { 
		  page_title:'',
		  page_excerpt:'',
		  title:this.props.title,
		  excerpt:this.props.excerpt,
		  page_heading:this.props.page_heading,
		  page_text:this.props.page_text
		}
	}
	componentDidMount(){
		this.handleTitles();
		window.addEventListener("resize", this.handleTitles.bind(this));			
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.handleTitles.bind(this));
	}
	handleTitles(){
		let dis = this;
		if(dis.state.page_heading!=='' && window.innerWidth>1350){ 
			dis.setState({
				page_title : dis.state.page_heading
			})
		}
		else{	
			dis.setState({
				page_title: dis.state.title
			})
		}	
		if(dis.state.page_text!=='' && window.innerWidth>1350){ 
			dis.setState({
				page_excerpt:dis.state.page_text
			})
		}
		else{	
			dis.setState({
				page_excerpt: dis.state.excerpt
			})
		}
	}
	render(){				
		const { slug,title,excerpt,time,date,end_date,end_time,taxonomy,page_heading,page_text} = this.props;	
		if(title){
			let $date = date;
			if(end_date)
				$date += "-"+end_date;
			let $time = time;
			if(end_time)
				$time += "-"+end_time;
			let $dash = '';
			if(!excerpt)
				$dash = 'hide-dash';				
			
			return(
				<div className="event-item clearfix">
					<div className="date">
						<div className="day h1">
							{$date}
						</div>
						<div className="hour sm-txt">
							{$time} {this.props.clock} 
						</div>
					</div>

					<div className="title">
						<UISref to="root.programm.kalenderdetails" params={{item:slug}}>
							<a>
								<div className="h2" dangerouslySetInnerHTML={createMarkup(this.state.page_title)}></div>
							</a>	
						</UISref>
						<div className="info sm-txt">
							{
								taxonomy.map( (data,i)=>
									<span key={i} className={`event-cat ${$dash}`}>
										<UISref to="root.programm.kalender-kategorie.name" params={{item:data.slug}} >		
											<a>{data.name}</a>
										</UISref>	
									</span>
								)
							}{
								(excerpt) ?
								<span className="excerpt" dangerouslySetInnerHTML={createMarkup(this.state.page_excerpt)}></span>
								: null
							}
						</div>
					</div>
				</div>
		)
		}else
			return null
	}
}
export default SidebarKalender;


// WEBPACK FOOTER //
// ./src/components/SidebarKalender.js